// css
import '../css-scss/main.scss';

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index.js